import {
  AnalyticsDeductionDimension,
  IDeductionsByTypeAndReasonGroup,
  IDeductionsByTypeAndReasonRow,
} from "@/core/repositories/analytics";

export const normalizeDimensionValue = (value: string): AnalyticsDeductionDimension | null => {
  const normalized = value.trim().toUpperCase();

  if (normalized === "TYPE" || normalized === "DEDUCTION_TYPE" || normalized === "DEDUCTIONTYPE") {
    return "TYPE";
  }

  if (normalized === "REASON" || normalized === "GL_CODE" || normalized === "GLCODE") {
    return "REASON";
  }

  return null;
};

export const toTypeAndReasonGroups = (
  data: IDeductionsByTypeAndReasonGroup | IDeductionsByTypeAndReasonGroup[]
): IDeductionsByTypeAndReasonGroup[] => (Array.isArray(data) ? data : [data]);

export const splitMixedRowsIntoGroups = (
  groups: IDeductionsByTypeAndReasonGroup[]
): IDeductionsByTypeAndReasonGroup[] => {
  const allRows = groups.flatMap(group => group.rows);
  const hasTypeRows = allRows.some(row => row.deductionType != null);
  const hasReasonRows = allRows.some(row => row.glCode != null);

  if (groups.length > 1 || !hasTypeRows || !hasReasonRows) {
    return groups;
  }

  return [
    { dimension: "TYPE", rows: allRows.filter(row => row.deductionType != null) },
    { dimension: "REASON", rows: allRows.filter(row => row.glCode != null) },
  ];
};

export const getRowsForDimension = (
  groups: IDeductionsByTypeAndReasonGroup[],
  dimension: AnalyticsDeductionDimension
): IDeductionsByTypeAndReasonRow[] => {
  const normalizedGroups = splitMixedRowsIntoGroups(toTypeAndReasonGroups(groups));

  const matchedGroup = normalizedGroups.find(
    group => normalizeDimensionValue(String(group.dimension)) === dimension
  );

  if (matchedGroup?.rows.length) {
    return matchedGroup.rows;
  }

  const allRows = normalizedGroups.flatMap(group => group.rows);

  if (dimension === "TYPE") {
    return allRows.filter(row => row.deductionType != null);
  }

  return allRows.filter(row => row.glCode != null);
};
